export default "__VITE_ASSET__DzN$n9yj__"